export default __webpack_public_path__ + "static/media/BG.37c63b80.svg";